module.exports = "https://cdn.hellotech.com/client-assets/ht-video-preview-image_7587e525836ddd64a1c258f0892efc3f.jpg";